import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { PontosCriticosAgregadorIndicadorService } from '../services/pontos-criticos-agregador-indicador.service';


@Injectable({
  providedIn: 'root'
})
export class PontosCriticosAgregadorIndicadorResolver implements Resolve<boolean> {

  constructor(private service: PontosCriticosAgregadorIndicadorService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.idPontoCriticoPgIndicador);
  }
}